import {
  RoomStyle,
  RoomType,
} from "../../api/services/spaces/roomPropertiesService";

export type ImageComparisonData = {
  beforeURL: string;
  afterURL: string;
  label: string;
};

export type SimpleImageData = {
  url: string;
  id: string;
};

export const flags = {
  us: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Fflags%2Fus.webp?alt=media",
  canada:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Fflags%2Fcanada.webp?alt=media",
  world:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Flags%2F3.png?alt=media&token=d06e183d-939c-434e-9153-32d299799a01",
};

export const homepage = {
  whyUs:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Fwhy_us_background.webp?alt=media",
  step1:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2FSteps%2Fstep1.webp?alt=media",
  step2:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2FSteps%2Fstep2.webp?alt=media",
  step3:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2FSteps%2Fstep3.webp?alt=media",
  realEstateShake:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2FrealEstateShake.webp?alt=media",
};

export const testimonials = {
  aldenaireJamesT:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Faldenaire_james_t.webp?alt=media",
  aldenaireLogo:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Faldenaire_logo.webp?alt=media",
  borcelleBrianaG:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Fborcelle_briana_g.webp?alt=media",
  borcelleLogo:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Fborcelle_logo.webp?alt=media",
  bleaukeyHomesLogo:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Fbleukey_homes_logo.webp?alt=media",
  mansionsDianeT:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Fmansions_diane_t.webp?alt=media",
  mansionsLogo:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Fmansions_logo.webp?alt=media",
  michaelS:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Fmichael_s.webp?alt=media",
  mikeS:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Fmike_s.webp?alt=media",
  realEstatePropertyLogo:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Freal_estate_property_logo.webp?alt=media",
  rimberioLogo:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Frimberio_logo.webp?alt=media",
  rimberioPatriciaG:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Frimberio_patricia_g.webp?alt=media",
  laranaLogo:
    "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/Homepage%2Freviews%2Flarana_logo.webp?alt=media",
};

export const sampleRooms: SimpleImageData[] = [
  {
    url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/SampleRoomPictures%2FNew%2Fsample1.jpg?alt=media&token=c34d7436-5b53-41e8-ab8e-507532c53e7c",
    id: "sample1vsx",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/SampleRoomPictures%2FNew%2Fsample2.jpg?alt=media&token=ee08dc66-5fd5-48ee-98e2-3afc638a7986",
    id: "sample2vsx",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/SampleRoomPictures%2FNew%2Fsample3.jpg?alt=media&token=b4603087-e574-49f9-aad2-8d19c32a8331",
    id: "sample3vsx",
  },
  {
    url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/SampleRoomPictures%2FNew%2Fsample4.jpg?alt=media&token=d4a06bee-068f-4e69-bf74-4539ad31ac9f",
    id: "sample4vsx",
  },
];
export const beforeAndAftersGallery: ImageComparisonData[] = [
  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_1_before_new.webp?alt=media&token=4f663e1a-26f5-4047-bf70-849cb9be5dfb",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_1_after.webp?alt=media",
    label: "Living room - Modern",
  },

  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_2_before.webp?alt=media",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_2_after.webp?alt=media",
    label: "Living room - Modern",
  },

  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fbedroom_modern_2_before.webp?alt=media",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fbedroom_modern_2_after.webp?alt=media",
    label: "Bedroom - contemporary",
  },

  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fremove_furniture_before.webp?alt=media",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fremove_furniture_after.webp?alt=media",
    label: "Remove furniture",
  },

  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_3_before.webp?alt=media",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_3_after.webp?alt=media",
    label: "Living room - modern",
  },

  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_4_before.webp?alt=media",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_4_after.webp?alt=media",
    label: "Living room - modern",
  },
  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_5_before_new.webp?alt=media&token=97e744af-b8b4-4905-8e9d-c7963c33b4a5",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_5_after.webp?alt=media",
    label: "Living room - contemporary",
  },
  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_6_before.webp?alt=media",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_modern_6_after.webp?alt=media",
    label: "Living room - contemporary",
  },
  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery-JPGs%2F50.webp?alt=media&token=f64d5d2c-711a-4f9d-8dc6-f9af244eee47",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery-JPGs%2F51.webp?alt=media&token=f64d5d2c-711a-4f9d-8dc6-f9af244eee47",
    label: "Bedroom - Contemporary",
  },
  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_coastal_before_new.webp?alt=media&token=07d0cfa3-b0f1-4de4-92e9-c7508bdfb30a",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_coastal_after.webp?alt=media",
    label: "Living room - Coastal",
  },

  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_industrial_before_new.webp?alt=media&token=234a4aec-cde1-463f-b50e-15a5c469867e",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fliving_room_industrial_after.webp?alt=media",
    label: "Living Room - Industrial",
  },

  {
    beforeURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fhomeoffice_before.webp?alt=media",
    afterURL:
      "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/BeforeAfterGallery%2Fhomeoffice_after.webp?alt=media",
    label: "Home office",
  },
];

export const INTERACTIVE_IMAGES: {
  [key in RoomType]?: {
    label: string;
    styles: {
      [key in RoomStyle | "original"]?: {
        label: string;
        url: string;
      };
    };
  };
} = {
  [RoomType.Bedroom]: {
    label: "Bedroom",
    styles: {
      original: {
        label: "Original",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_original.webp?alt=media",
      },
      [RoomStyle.Standard]: {
        label: "Standard",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_standard.webp?alt=media",
      },
      [RoomStyle.Modern]: {
        label: "Modern",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_modern.webp?alt=media",
      },
      [RoomStyle.Scandinavian]: {
        label: "Scandinavian",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_scandinavian.webp?alt=media",
      },
      [RoomStyle.Industrial]: {
        label: "Industrial",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_industrial.webp?alt=media",
      },
      [RoomStyle.Midcentury]: {
        label: "Midcentury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_midcentury.webp?alt=media",
      },
      [RoomStyle.Luxury]: {
        label: "Luxury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_luxury.webp?alt=media",
      },
      [RoomStyle.Coastal]: {
        label: "Coastal",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_coastal.webp?alt=media",
      },
      [RoomStyle.Farmhouse]: {
        label: "Farmhouse",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fbedroom%2Fbedroom_farmhouse.webp?alt=media",
      },
    },
  },
  [RoomType.LivingRoom]: {
    label: "Living room",
    styles: {
      original: {
        label: "Original",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_original.webp?alt=media",
      },
      [RoomStyle.Standard]: {
        label: "Standard",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_standard.webp?alt=media",
      },
      [RoomStyle.Modern]: {
        label: "Modern",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_modern.webp?alt=media",
      },
      [RoomStyle.Scandinavian]: {
        label: "Scandinavian",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_scandinavian.webp?alt=media",
      },
      [RoomStyle.Industrial]: {
        label: "Industrial",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_industrial.webp?alt=media",
      },
      [RoomStyle.Midcentury]: {
        label: "Midcentury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_midcentury.webp?alt=media",
      },
      [RoomStyle.Luxury]: {
        label: "Luxury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_luxury.webp?alt=media",
      },
      [RoomStyle.Coastal]: {
        label: "Coastal",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_coastal.webp?alt=media",
      },
      [RoomStyle.Farmhouse]: {
        label: "Farmhouse",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Flivingroom%2Flivingroom_farmhouse.webp?alt=media",
      },
    },
  },
  [RoomType.HomeOffice]: {
    label: "Home office",
    styles: {
      original: {
        label: "Original",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_original.webp?alt=media",
      },
      [RoomStyle.Standard]: {
        label: "Standard",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_standard.webp?alt=media",
      },
      [RoomStyle.Modern]: {
        label: "Modern",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_modern.webp?alt=media",
      },
      [RoomStyle.Scandinavian]: {
        label: "Scandinavian",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_scandinavian.webp?alt=media",
      },
      [RoomStyle.Industrial]: {
        label: "Industrial",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_industrial.webp?alt=media",
      },
      [RoomStyle.Midcentury]: {
        label: "Midcentury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_midcentury.webp?alt=media",
      },
      [RoomStyle.Luxury]: {
        label: "Luxury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_luxury.webp?alt=media",
      },
      [RoomStyle.Coastal]: {
        label: "Coastal",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_coastal.webp?alt=media",
      },
      [RoomStyle.Farmhouse]: {
        label: "Farmhouse",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fhomeoffice%2Fhomeoffice_farmhouse.webp?alt=media",
      },
    },
  },
  [RoomType.DiningRoom]: {
    label: "Dining room",
    styles: {
      original: {
        label: "Original",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_original.webp?alt=media",
      },
      [RoomStyle.Standard]: {
        label: "Standard",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_standard.webp?alt=media",
      },
      [RoomStyle.Modern]: {
        label: "Modern",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_modern.webp?alt=media",
      },
      [RoomStyle.Scandinavian]: {
        label: "Scandinavian",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_scandinavian.webp?alt=media",
      },
      [RoomStyle.Industrial]: {
        label: "Industrial",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_industrial.webp?alt=media",
      },
      [RoomStyle.Midcentury]: {
        label: "Midcentury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_midcentury.webp?alt=media",
      },
      [RoomStyle.Luxury]: {
        label: "Luxury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_luxury.webp?alt=media",
      },
      [RoomStyle.Coastal]: {
        label: "Coastal",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_coastal.webp?alt=media",
      },
      [RoomStyle.Farmhouse]: {
        label: "Farmhouse",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fdiningroom%2Fdiningroom_farmhouse.webp?alt=media",
      },
    },
  },
  [RoomType.KidsRoom]: {
    label: "Kids room",
    styles: {
      original: {
        label: "Original",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_original.webp?alt=media",
      },
      [RoomStyle.Standard]: {
        label: "Standard",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_standard.webp?alt=media",
      },
      [RoomStyle.Modern]: {
        label: "Modern",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_modern.webp?alt=media",
      },
      [RoomStyle.Scandinavian]: {
        label: "Scandinavian",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_scandinavian.webp?alt=media",
      },
      [RoomStyle.Industrial]: {
        label: "Industrial",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_industrial.webp?alt=media",
      },
      [RoomStyle.Midcentury]: {
        label: "Midcentury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_midcentury.webp?alt=media",
      },
      [RoomStyle.Luxury]: {
        label: "Luxury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_luxury.webp?alt=media",
      },
      [RoomStyle.Coastal]: {
        label: "Coastal",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_coastal.webp?alt=media",
      },
      [RoomStyle.Farmhouse]: {
        label: "Farmhouse",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Fkidsroom%2Fkidsroom_farmhouse.webp?alt=media",
      },
    },
  },
  [RoomType.Outdoor]: {
    label: "Outdoor",
    styles: {
      original: {
        label: "Original",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_original.webp?alt=media",
      },
      [RoomStyle.Standard]: {
        label: "Standard",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_standard.webp?alt=media",
      },
      [RoomStyle.Modern]: {
        label: "Modern",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_modern.webp?alt=media",
      },
      [RoomStyle.Scandinavian]: {
        label: "Scandinavian",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_scandinavian.webp?alt=media",
      },
      [RoomStyle.Industrial]: {
        label: "Industrial",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_industrial.webp?alt=media",
      },
      [RoomStyle.Midcentury]: {
        label: "Midcentury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_midcentury.webp?alt=media",
      },
      [RoomStyle.Luxury]: {
        label: "Luxury",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_luxury.webp?alt=media",
      },
      [RoomStyle.Coastal]: {
        label: "Coastal",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_coastal.webp?alt=media",
      },
      [RoomStyle.Farmhouse]: {
        label: "Farmhouse",
        url: "https://firebasestorage.googleapis.com/v0/b/virtual-staging-pro-ai.appspot.com/o/InteractiveGallery%2Foutdoor%2Foutdoor_farmhouse.webp?alt=media",
      },
    },
  },
};
